function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  stroke: "#416DE0",
  fill: "#FFF",
  cx: 7,
  cy: 7,
  r: 7.5
}), React.createElement("circle", {
  fill: "#416DE0",
  cx: 7,
  cy: 7,
  r: 4
}));

var SvgRadioCircleQuestion = function SvgRadioCircleQuestion(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg transform='translate(-59.000000, -405.000000)'%3E %3Cg transform='translate(60.000000, 401.000000)'%3E %3Cg transform='translate(0.000000, 5.000000)'%3E %3Ccircle stroke='%23416DE0' fill='%23FFFFFF' cx='7' cy='7' r='7.5'%3E%3C/circle%3E %3Ccircle fill='%23416DE0' cx='7' cy='7' r='4'%3E%3C/circle%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgRadioCircleQuestion as ReactComponent };